/**
 * useNicheFinderTeaser — busca a amostra diária do teaser (GET /teaser).
 *
 * Usado SOMENTE no modo bloqueado (free/basic/lite). A amostra é fixa por
 * dia no backend (seed diária) e o endpoint responde com
 * Cache-Control: private, max-age=3600 — o cache de módulo aqui (60 min)
 * evita refetch ao navegar entre páginas dentro da sessão.
 */
import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const API = (import.meta.env.VITE_BACKEND_URL || '') + '/api';

let _teaserCache = null;
let _teaserCacheAt = 0;
let _inFlight = null; // dedup: StrictMode/montagens simultâneas dividem 1 request
const CACHE_TTL_MS = 60 * 60 * 1000;

export function useNicheFinderTeaser() {
  const [teaser, setTeaser] = useState(_teaserCache);
  const [loading, setLoading] = useState(!_teaserCache);
  const [error, setError] = useState(null);

  const fetchTeaser = useCallback(async (force = false) => {
    const fresh = _teaserCache && (Date.now() - _teaserCacheAt) < CACHE_TTL_MS;
    if (fresh && !force) {
      setTeaser(_teaserCache);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      if (!_inFlight) {
        const token = localStorage.getItem('token');
        _inFlight = axios
          .get(`${API}/nichos-virais/teaser`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .finally(() => { _inFlight = null; });
      }
      const { data } = await _inFlight;
      _teaserCache = data;
      _teaserCacheAt = Date.now();
      setTeaser(data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTeaser(false);
  }, [fetchTeaser]);

  return { teaser, loading, error, refetch: () => fetchTeaser(true) };
}
